import { render, staticRenderFns } from "./TaskModelFilter.vue?vue&type=template&id=a846a8d0&"
import script from "./TaskModelFilter.vue?vue&type=script&lang=js&"
export * from "./TaskModelFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports